import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-finish-assessment',
  templateUrl: './finish-assessment.component.html',
  styleUrls: ['./finish-assessment.component.scss']
})
export class FinishAssessmentComponent implements OnInit {

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 

    if(dataSvc != null && dataSvc !== undefined){
      var exisitingLangauge = localStorage.getItem("userslanguage");
      if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
        this.dataSvc.changeLangauge(exisitingLangauge);
      }
      else{
        this.translate.setDefaultLang("en");
        this.translate.use("en");
      }
     }

  }

  ngOnInit() {
  }


}
